// extracted by mini-css-extract-plugin
export default {"app-header":"Wizard_app-header__VIdsd","app-container":"Wizard_app-container__E3EXH","app-container-no-header":"Wizard_app-container-no-header__5XWj7"};